/**
 * Utility function to clear all app related cookies.
 */
export function clearAllAuthStorage() {
  clearAuthCookies();
  localStorage.removeItem("sans-auth-id");
  localStorage.removeItem("sans-auth-access");
  localStorage.removeItem("sans-auth-refresh");
}

/**
 * Utility function to Clear app defined cookies.
 */
export function clearAuthCookies() {
  const attrs = `Path=/; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}`;

  // set expiry to one second in the past
  const expired = new Date(Date.now() - 1000).toUTCString();

  document.cookie = `id=; ${attrs}; Max-Age=0; Expires=${expired}`;
  document.cookie = `access_id=; ${attrs}; Max-Age=0; Expires=${expired}`;
  console.debug("[auth] cleared app cookies");
}

/**
 * Utility function to normalize the logout query parameter provided by OIDC providers
 * @param value the logout query param value
 * @returns boolean
 */
export function normalizeLogout(value: unknown): boolean {
  if (value === true) return true;
  if (value === false || value == null) return false;

  if (typeof value === "string") {
    const v = value.toLowerCase();
    return v === "true" || v === "1" || v === "yes";
  }

  if (typeof value === "number") {
    return value === 1;
  }

  return false;
}
